import React, { useEffect, useState } from 'react';
import './BrandSettings.scss';

import { useDispatch, useSelector } from 'react-redux';
import { SET_BRANDSETTINGS } from '../../../redux/templates/templateReducer';

import { ApiService } from '../../../services/api-service';
import { container } from 'tsyringe';
import { TemplateService } from '../../../services/template-service';
import { pickTextColorBasedOnBgColorAdvanced, useSharedState,  } from '../../../utils/helpers';
import { IOSSwitch } from '../../Switches/Switches';
import { ActionType, GroupType } from '../../../models/actionClass';

import ExplainTips from '../../utils/ExplainTips';
import ColorSelector from '../../utils/ColorSelector';



interface BrandThemeProps {
  primaryColor: string;
  primaryText?: string;
  secondaryText?: string;
  theme: string;
  selectTheme: any;
}


export const BrandTheme = (props: BrandThemeProps) => {

  const brandSettingsState = useSelector((state: any) => state.templates.brandsettings);

  const IsThemeSelected = (theme) => {
    // to show black border theme has to be selectable and selected
    return (props.selectTheme && brandSettingsState.selectedTheme === theme) ? 'selected' : '';
  }

  let fgColor = props.primaryColor;
  let bgColor = 'transparent';
  let borderColor = props.primaryColor;
  let primaryText = props?.primaryText || 'Primary Long Text';
  let secondaryText = props?.secondaryText || 'Secondary Text';
  // const weight = (props.theme === 'lower_third3' ? 'bold' : 'normal'); // declare as const
  const weight = 'bold'; // declare as const

  if (props.theme === 'lower_third1') {
    fgColor = pickTextColorBasedOnBgColorAdvanced(props.primaryColor, '#FFFFFF', '#4a4a4a'),
    bgColor = props.primaryColor;
    borderColor = 'transparent';
  }
  if (props.theme !== 'lower_third1') {
    fgColor = 'black';
  }

  const onSelect = () => {
    if (props.selectTheme) {
      props.selectTheme(props.theme);
    }
  }

  return (
    <div className={'theme ' + props.theme + ' ' + IsThemeSelected(props.theme)} onClick={onSelect}>
      { props.theme === 'lower_third3' &&
        <div className="container-shifted" style={{'background': borderColor}}></div>
      }
      <div className="container" style={{'borderColor': borderColor}}>
        <div className='primaryText' style={{'color': fgColor, 'background': bgColor, 'fontWeight': weight}}>{primaryText}</div>
        <div className='secondaryText'>{secondaryText}</div>
      </div>
    </div>
  )
}

// const BrandSettings = React.memo(function BrandSettingsFn() {
  const BrandSettings = () => {

  const brandSettingsState = useSelector((state: any) => state.templates.brandsettings);
  const dispatch = useDispatch();

  const [apiService] = useState(container.resolve(ApiService));
  const [templateService] = useState(container.resolve(TemplateService));
  const [brandSettings, setBrandSettings] = useSharedState(apiService.brandSettings$);

  const [initialColor, setInitialColor] = useState(brandSettingsState?.primaryColor || "#0D62C5");
  const primaryColor = brandSettingsState?.primaryColor || "#0D62C5";

  const onValidatePrimary = (color, updateReason = true) => {
    const nametagsActive = brandSettingsState?.nametagsActive || false;
    const primaryColor = color;
    const selectedTheme = brandSettingsState?.selectedTheme || "lower_third1";
    dispatch({type: SET_BRANDSETTINGS, payload: { nametagsActive, primaryColor, selectedTheme}});
    localStorage.setItem('primaryColor', primaryColor);
    const settings = JSON.stringify({ nametagsActive, primaryColor, selectedTheme});
    apiService.forceLayerSend = true;
    setBrandSettings(settings);
    // apiService.myProcessedNumber++;
    // apiService.saveChannel('brandsettings');

    // read nametag templates and update bgColor
    if (updateReason) {
      apiService.updateReason = {group: GroupType.BRANDSETTING, action: ActionType.PRIMARYCOLOR, value: primaryColor};
    }
    const nameTags = templateService.nametags$.getValue();
    if (nameTags.length>0) {
      nameTags.forEach((nt: any) => {if (nt.isVisible) {nt.bgColor = primaryColor}});
      templateService.nametags$.next(nameTags);
    }

  }


  const onToggleActive = (force = undefined, updateReason = true) => {
    const nametagsActive = (force === undefined) ? !(brandSettingsState?.nametagsActive || false) : force;
    const primaryColor = brandSettingsState?.primaryColor || "#0D62C5";
    const selectedTheme = brandSettingsState?.selectedTheme || "lower_third1";
    dispatch({type: SET_BRANDSETTINGS, payload: { nametagsActive, primaryColor, selectedTheme}});
    localStorage.setItem('nametagsActive', JSON.stringify(nametagsActive));
    const settings = JSON.stringify({ nametagsActive, primaryColor, selectedTheme});
    apiService.forceLayerSend = true;
    setBrandSettings(settings);
    if (updateReason) {
      apiService.updateReason = {group: GroupType.BRANDSETTING, action: ActionType.NAMETAGS, value: nametagsActive };
    }

    // apiService.myProcessedNumber++;
    // apiService.saveChannel('brandsettings nametags');
    // force next update in showLiveProducer to be send
  }

  const onSelectTheme = (theme, updateReason = true) => {
    const nametagsActive = brandSettingsState?.nametagsActive || false;
    const primaryColor = brandSettingsState?.primaryColor || "#0D62C5";
    const selectedTheme = theme;
    dispatch({type: SET_BRANDSETTINGS, payload: { nametagsActive, primaryColor, selectedTheme}});
    localStorage.setItem('selectedTheme', selectedTheme);
    const settings = JSON.stringify({ nametagsActive, primaryColor, selectedTheme});
    apiService.forceLayerSend = true;
    setBrandSettings(settings);

    if (updateReason) {
      apiService.updateReason = {group: GroupType.BRANDSETTING, action: ActionType.THEME, value: selectedTheme};
    }
  }

  useEffect(() => {
    console.log('redux state updated', brandSettingsState);
  }, [brandSettingsState]);


  useEffect(() => {
    // apply update from server api
    try {
      const settings = JSON.parse(brandSettings);
      if (settings.nametagsActive !== brandSettingsState?.nametagsActive) {
        onToggleActive(settings.nametagsActive, false);
      }
      if (settings.primaryColor !== brandSettingsState?.primaryColor) {
        onValidatePrimary(settings.primaryColor, false);
        setInitialColor(settings.primaryColor);
      }
      if (settings.selectedTheme !== brandSettingsState?.selectedTheme) {
        onSelectTheme(settings.selectedTheme, false);
      }
    } catch (e) {}
  }, [brandSettings]);

  return (

      <ul className="brandsettings">


        <li key={"primaryColor"} className="primary-color">
          <div className='title'>Primary Color</div>

          <ColorSelector primaryColor={initialColor} onColorSelect={(c) => setInitialColor(c)} onColorValidate={(c) => onValidatePrimary(c)}></ColorSelector>

        </li>
        <li key="theme">
          <div className='title'>Theme</div>
          <div className='themes'>
            <div className="theme-container">
              <BrandTheme primaryColor={primaryColor} theme="lower_third1" selectTheme={() => onSelectTheme('lower_third1')}></BrandTheme>
            </div>
            <div className="theme-container">
              <BrandTheme primaryColor={primaryColor} theme="lower_third2" selectTheme={() => onSelectTheme('lower_third2')}></BrandTheme>
            </div>
            <div className="theme-container">
              <BrandTheme primaryColor={primaryColor} theme="lower_third3" selectTheme={() => onSelectTheme('lower_third3')}></BrandTheme>
            </div>
          </div>
        </li>

        <li key="nametag">
          <div className="sw-container">
            <div className="block">Name Tags
            <ExplainTips text={'Show participant names in the bottom corner of the video. You can change the style of the name tags in your brand settings'} tipStyle={{}}></ExplainTips>
            </div>
            <div className="block">
              <div className="switch-label">{brandSettingsState?.nametagsActive ? 'On' : 'Off'}</div>
              <div>
                <IOSSwitch
                className='switch'
                checked={brandSettingsState?.nametagsActive || false}
                onChange={() => onToggleActive()}
                />
              </div>
            </div>
          </div>
        </li>

      </ul>
  );

}

export default BrandSettings;